import Marquee from "react-fast-marquee";
import { useLang } from "../context/LanguageContext";

export const MarqueeStrip = () => {
  const { t } = useLang();
  const items = t("marquee");
  const list = Array.isArray(items) ? items : [];

  return (
    <div
      className="relative border-y border-white/10 bg-[#0A0A0A] py-8 md:py-10 overflow-hidden"
      data-testid="marquee-strip"
    >
      <Marquee gradient={false} speed={38} pauseOnHover={false}>
        {list.concat(list).map((word, i) => (
          <span
            key={i}
            className="font-serif italic text-[#F4F4F0]/70 text-[6vw] md:text-[3.6vw] leading-none px-10 md:px-16 flex items-center gap-10 md:gap-16"
          >
            {word}
            <span className="inline-block w-[6px] h-[6px] rounded-full bg-[#C5A059]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
